// MARK://dhk8/admin-shell/i18n/es-MX
// es-MX strings for the merchant admin. Flat key→string map; call t('key').
// Mirrors apps/dhk8-pos/src/i18n/es-MX.ts conventions (`<area>.<thing>`).

export const esMX = {
  'common.loading': 'Cargando…',
  'common.retry': 'Reintentar',
  'common.cancel': 'Cancelar',
  'common.save': 'Guardar',
  'common.create': 'Crear',
  'common.delete': 'Eliminar',
  'common.edit': 'Editar',
  'common.close': 'Cerrar',
  'common.search': 'Buscar',
  'common.empty': 'Sin resultados',
  'common.back': 'Volver',
  'common.next': 'Siguiente',
  'common.done': 'Listo',

  'app.title': 'NintaiGO Admin',
  'app.tag': 'panel del comerciante',

  'auth.title': 'Acceso al panel',
  'auth.pin': 'PIN',
  'auth.email': 'Correo y contraseña',
  'auth.pinId': 'ID (6 dígitos)',
  'auth.pinPassword': 'Clave (6 dígitos)',
  'auth.emailLabel': 'Correo',
  'auth.passwordLabel': 'Contraseña',
  'auth.enter': 'Entrar',
  'auth.devLogin': 'Entrar (modo demo · sin backend)',

  'theme.toLight': 'Cambiar a tema claro',
  'theme.toDark': 'Cambiar a tema oscuro',

  'nav.dashboard': 'Inicio',
  'nav.catalog': 'Catálogo',
  'nav.modifiers': 'Extras',
  'nav.combos': 'Combos',
  'nav.ingredients': 'Insumos',
  'nav.organizations': 'Org.',
  'nav.recipes': 'Recetario',
  'nav.menus': 'Menús',
  'nav.units': 'Unidades',
  'nav.floor': 'Plano',
  'nav.qrCodes': 'QRs',
  'nav.reservations': 'Reservas',
  'nav.waitlist': 'Cola',
  'nav.users': 'Permisos',
  'nav.audit': 'Auditoría',
  'nav.devices': 'Perif.',
  'nav.fiscal': 'Fiscal',
  'nav.reports': 'Reportes',
  'nav.invoices': 'Facturas',
  'nav.inventory': 'Stock',
  'nav.lots': 'Lotes',
  'nav.movements': 'Movimientos',
  'nav.customers': 'Clientes',
  'nav.customersCrm': 'Clientes',
  'nav.customersFiscal': 'Fiscales',
  'nav.suppliers': 'Proveedor',
  'nav.purchaseOrders': 'Compras',
  'nav.impersonate': 'Suplantar',
  'nav.superadmin': 'Terceros',
  'nav.logout': 'Salir',
} as const

export type I18nKey = keyof typeof esMX
export function t(key: I18nKey): string {
  return esMX[key] ?? key
}
